import React, { useState } from "react";
import { useForm } from "react-hook-form";
import IntlTelInput from "react-intl-tel-input";

function ArrowIcon({ className = "" }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="152.816"
      height="18.922"
      viewBox="0 0 152.816 18.922"
      className={className}
    >
      <g
        id="flecha-correcta"
        transform="translate(113.75 -132)"
        opacity="0.557"
      >
        <g id="Grupo_936" data-name="Grupo 936" transform="translate(0 132)">
          <path
            id="Trazado_361"
            data-name="Trazado 361"
            d="M38.618,140.381h0l-7.974-7.935a1.526,1.526,0,0,0-2.153,2.163l5.353,5.328H-112.225a1.526,1.526,0,0,0-1.526,1.526,1.526,1.526,0,0,0,1.526,1.526H33.843l-5.353,5.328a1.526,1.526,0,0,0,2.153,2.163l7.974-7.935h0A1.527,1.527,0,0,0,38.618,140.381Z"
            transform="translate(0 -132)"
            fill="#41b8a3"
          />
        </g>
      </g>
    </svg>
  );
}

export function AmbassadorContactForm() {
  const { register, handleSubmit, reset } = useForm({});
  const [phone, setPhone] = useState();

  const onChange = (_, phoneNumber, country) => {
    const dialCode = country.dialCode;
    const expression = `\\+${dialCode}`;
    const regex = new RegExp(expression);
    const withoutDial = phoneNumber.replace(regex, "");
    const internationalNumber = `+${country.dialCode}` + `${withoutDial}`;
    setPhone(internationalNumber);
  };

  const countries = [
    { value: "aw", name: "Aruba" },
    { value: "au", name: "Australia" },
    { value: "co", name: "Colombia" },
    { value: "es", name: "España" },
    { value: "us", name: "Estados Unidos" },
    { value: "mx", name: "México" },
    { value: "do", name: "República Dominicana" },
    { value: "other", name: "Otro" },
  ];

  const onSubmit = async (data) => {
    const selectedCountry = countries.find((c) => c.value === data.country);
    const countryName = selectedCountry ? selectedCountry.name : "";

    const zohoInfo = {
      data: [
        {
          Name: data.name,
          Last_Name: data.last_name,
          Tel_fono_1: phone,
          Email: data.email,
          Pa_s_de_residencia: countryName,
          Estrategia_de_campa_a: "Embajadores Coninsa",
          Medio_publicitario: "www.coninsa.co",
          Owner: { id: "2528071000285668006" },
          layout: { id: "2528071001427402022" },
        },
      ],
    };

    try {
      const response = await fetch(
        "https://api.coninsa.co/api/v2/zohocrm-create-records-custom-module",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(zohoInfo),
        }
      );

      const responseBody = await response.json();

      if (!response.ok) {
        console.error("Error en el envío:", responseBody);
        return;
      }

      reset();
      setTimeout(() => {
        window.location.replace(`/gracias?destination=${window.location.pathname}`);
      }, 500);

    } catch (error) {
      console.error("Error general:", error);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="grid gap-8 lg:grid-cols-[auto_38%]">
        <div className="block">
          <h5 className="mb-6 text-xl !leading-none text-s2-teal lg:text-2xl">
            <span className="block font-bold">Te recompensamos</span>
            por cada nuevo comprador que refieras
          </h5>

          <div className="flex gap-6 max-md:w-[calc(100vw_-_100px)] max-md:overflow-auto max-md:pb-4 lg:grid lg:grid-cols-2">
            <div className="max-md:w-9/12 max-md:flex-shrink-0">
              <div className="flex items-center gap-4">
                <div className="mb-2 inline-flex size-10 flex-shrink-0 items-center justify-center rounded-full bg-blue-800 font-bold text-white">
                  1
                </div>

                <ArrowIcon className="lg:hidden" />
              </div>
              <div>
                <strong className="block">Regístrate como embajador</strong>
                Déjanos tus datos y accede a nuestro plan de recompensas
                escalonadas.
              </div>
            </div>
            <div className="max-md:w-9/12 max-md:flex-shrink-0">
              <div className="flex items-center gap-4">
                <div className="mb-2 inline-flex size-10 flex-shrink-0 items-center justify-center rounded-full bg-blue-800 font-bold text-white">
                  2
                </div>
                <ArrowIcon className="lg:hidden" />
              </div>
              <div>
                <strong className="block">
                  Comparte nuestras oportunidades
                </strong>
                Recomienda nuestros proyectos a conocidos fuera del país
                interesados en invertir en Colombia.
              </div>
            </div>
            <div className="max-md:w-9/12 max-md:flex-shrink-0">
              <div className="flex items-center gap-4">
                <div className="mb-2 inline-flex size-10 flex-shrink-0 items-center justify-center rounded-full bg-blue-800 font-bold text-white">
                  3
                </div>
                <ArrowIcon className="lg:hidden" />
              </div>
              <div>
                <strong className="block">Conéctanos con tu referido</strong>
                Un asesor se pondrá en contacto contigo para conocer a tu
                referido y acompañarlo en todo el proceso de inversión.
              </div>
            </div>
            <div className="max-md:w-9/12 max-md:flex-shrink-0">
              <div className="flex items-center gap-4">
                <div className="mb-2 inline-flex size-10 flex-shrink-0 items-center justify-center rounded-full bg-blue-800 font-bold text-white">
                  4
                </div>
                <ArrowIcon className="lg:hidden" />
              </div>
              <div>
                <strong className="block">Recibe tu recompensa</strong> Si tu
                referido realiza una inversión, tú comienzas a ganar de acuerdo
                al número de compradores referidos.
              </div>
            </div>
          </div>
        </div>

        <div className="co-form flex-col gap-3">
          <div className="font-semibold">Tus datos</div>
          <div className="form-control">
            <input
              {...register("name")}
              placeholder="Nombres"
              type="text"
              required
            />
          </div>
          <div className="form-control">
            <input
              {...register("last_name")}
              type="text"
              placeholder="Apellidos"
              required
            />
          </div>

          <div className="form-control is-intl-tel">
            <IntlTelInput
              {...register("phone")}
              id="phone"
              placeholder="Número de contacto"
              defaultCountry={"co"}
              onPhoneNumberChange={onChange}
              telInputProps={{ required: true }}
              className="w-full"
            />
          </div>
          <div className="form-control">
            <input
              {...register("email")}
              type="email"
              placeholder="Correo electrónico"
              required
            />
          </div>

          <div className="form-control">
            <label>País de Residencia</label>
            <select {...register("country")}>
              {countries.map(({ value, name }) => (
                <option key={value} value={value}>
                  {name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-control is-radio">
            <input
              {...register("accept_conditions")}
              type="checkbox"
              id="accept-conditions"
              required
            />
            <label htmlFor="accept-conditions">
              Autorizo el tratamiento de la{" "}
              <a
                href="https://www.coninsa.co/politica-de-tratamiento-de-datos-personales-de-coninsa/"
                target="_blank"
                className="text-teal-600"
              >
                política de datos personales y{" "}
              </a>
              <a
                href="https://d2xt7650da4t25.cloudfront.net/s3fs-public/2025-07/TERMINOS%20Y%20CONDICIONES%20Embajadores%20Coninsa.pdf"
                target="_blank"
                className="text-teal-600"
              >
                términos y condiciones embajadores
              </a>
            </label>
          </div>

          <button className="co-button !bg-s2-dark-blue font-semibold !text-white lg:!text-base">
            Enviar mi información
          </button>
        </div>
      </div>
    </form>
  );
}
